import Mute from '@/javascripts/components/Mute';

document.addEventListener('DOMContentLoaded', () => {
  new Mute().addToggleMuteEvent();
});
